/**
 * window.localStorage 简单封装
 */

const storage = {
  // 加标记防止key值被覆盖污染
  kbKey: (key) => {
    return `h5_tarc_${key}`;
  },
  set: (key, value) => {
    if (!key) {
      return;
    }
    window.localStorage.setItem(storage.kbKey(key), JSON.stringify(value));
  },
  get: (key) => {
    if (!key) {
      return;
    }
    const value = window.localStorage.getItem(storage.kbKey(key));
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  },
  remove: (key) => {
    if (!key) {
      return;
    }
    window.localStorage.removeItem(storage.kbKey(key));
  },
  clear: () => {
    window.localStorage.clear();
  },
};

export default storage;
